import React from "react";
import { Button } from "@/components/ui/button";
import { ArrowLeft, Flame, Phone } from "lucide-react";
import { PRICING_TIERS, WHATSAPP_LINK, ABOUT_IMAGE } from "@/lib/constants";

export default function Pricing() {
  return (
    <section
      id="pricing"
      className="relative py-20 md:py-28 overflow-hidden"
      data-testid="pricing-section"
      style={{
        background:
          "radial-gradient(900px 500px at 90% 10%, rgba(201,163,85,0.15), transparent 60%), linear-gradient(180deg, #0F3D2E 0%, #08281E 100%)",
      }}
    >
      <div className="grain-overlay" />
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl relative">
        <div className="text-center mb-14 fade-up">
          <div className="inline-flex items-center gap-2 text-brand-gold-light font-bold text-sm tracking-widest uppercase mb-3">
            <Flame className="w-4 h-4" /> العروض
          </div>
          <h2 className="font-heading text-3xl md:text-5xl font-extrabold text-white leading-tight">
            عروض <span className="text-gold-gradient">السيولة</span>
          </h2>
          <p className="mt-3 text-base md:text-lg text-white/75 max-w-2xl mx-auto">
            اختر المبلغ المناسب لك من جدول العروض — قيم شفافة بدون أي رسوم مخفية.
          </p>
        </div>

        <div className="grid lg:grid-cols-5 gap-10 items-center">
          {/* Pricing grid */}
          <div className="lg:col-span-3 grid grid-cols-1 sm:grid-cols-2 gap-3.5">
            {PRICING_TIERS.map((t, i) => (
              <div
                key={i}
                data-testid={`pricing-tier-${t.request}`}
                className="group relative rounded-2xl bg-white/5 border border-brand-gold/20 backdrop-blur-sm p-4 md:p-5 hover:bg-white/10 hover:border-brand-gold/50 transition-all fade-up"
                style={{ animationDelay: `${i * 0.05}s` }}
              >
                <div className="flex items-center justify-between">
                  <div className="flex items-baseline gap-1">
                    <span className="font-heading text-3xl md:text-4xl font-black text-gold-gradient">
                      {t.request.toLocaleString("en-US")}
                    </span>
                    <span className="text-xs font-bold text-white/60">ريال</span>
                  </div>
                  <ArrowLeft className="w-5 h-5 text-brand-gold" />
                  <div className="flex items-baseline gap-1">
                    <span className="font-heading text-3xl md:text-4xl font-black text-white">
                      {t.receive.toLocaleString("en-US")}
                    </span>
                    <span className="text-xs font-bold text-white/60">ريال</span>
                  </div>
                </div>
                <div className="mt-2 flex items-center justify-between">
                  <span className="text-[11px] text-white/50 font-semibold">المبلغ المطلوب</span>
                  <span className="text-[11px] text-brand-gold-light font-semibold">يتم سدادها</span>
                </div>
              </div>
            ))}

            <div className="sm:col-span-2 mt-2">
              <Button
                asChild
                size="lg"
                data-testid="pricing-contact-btn"
                className="w-full bg-brand-gold hover:bg-[#b08e4a] text-brand-green rounded-full h-14 text-base font-extrabold gap-2 shadow-xl"
              >
                <a href={WHATSAPP_LINK("أرغب في الحصول على سيولة — ما هي المبالغ المتاحة لي؟")} target="_blank" rel="noopener noreferrer">
                  <Phone className="w-5 h-5" />
                  تواصل معنا الآن
                </a>
              </Button>
            </div>
          </div>

          {/* Image side */}
          <div className="lg:col-span-2 relative fade-up-delay-2">
            <div className="relative max-w-[420px] mx-auto">
              <div className="absolute -inset-6 bg-brand-gold/15 blur-3xl rounded-full" />
              <div className="relative rounded-[28px] overflow-hidden ring-1 ring-brand-gold/30 shadow-[0_30px_70px_-20px_rgba(0,0,0,0.5)]">
                <img
                  src={ABOUT_IMAGE}
                  alt="ميرال كروب - حلولك المالية الذكية"
                  className="w-full h-auto object-cover"
                  data-testid="pricing-image"
                  loading="lazy"
                />
              </div>
              <div className="absolute -top-4 -end-4 bg-brand-gold text-brand-green rounded-2xl px-4 py-2 font-heading font-extrabold shadow-xl rotate-[-4deg]">
                للمواطن والمقيم
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
